import { createFileRoute } from '@tanstack/react-router';
import {
  ContainerTypeLegacy,
  DevicesLayout,
  getUserPermissionTooltipText,
  navigateToError,
  useGetViewer,
  UserRole,
} from '@amber-ui/core';

function DevicesRoute() {
  const { bin } = Route.useSearch();
  const { viewer } = useGetViewer();

  if (!bin) return null;

  const role = viewer?.user?.role;
  // Restrictive default: readOnly=true while viewer is loading (role undefined) prevents a brief
  // window where actions are enabled before the role check resolves.
  const readOnly = !role || role === UserRole.ReadOnly || role === UserRole.FanAccess;
  const disabledTooltipText = readOnly && role ? getUserPermissionTooltipText(role) : '';

  return (
    <DevicesLayout
      container_id={bin}
      container_type={ContainerTypeLegacy.bin}
      onError={() => {
        navigateToError();
      }}
      onHubAssignmentSuccess={() => {}}
      onAssignFanControllerSuccess={() => {}}
      onUnassignFanControllerSuccess={() => {}}
      readOnly={readOnly}
      disabledTooltipText={disabledTooltipText}
    />
  );
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/devices')({
  component: DevicesRoute,
});
